(function () {
  'use strict';

  const SEL_CHARM_SELECTOR = '[data-ff-charm-selector]';
  const SEL_VARIANT_INPUT = '.product-variant-id';
  const CLASS_SELECTED = 'ff-is-selected';

  function formatMoney(cents) {
    const lang = document.documentElement.lang || 'en';
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const hasCents = cents % 100 !== 0;
    return new Intl.NumberFormat(lang, {
      style: 'currency',
      currency,
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0,
    }).format(cents / 100);
  }

  function getSection(el) {
    return el.closest('.shopify-section') || document;
  }

  function initCharmSelector(container) {
    const options = container.querySelectorAll('[data-ff-charm-variant-id]');
    if (!options.length) return;

    const isMulti = container.hasAttribute('data-ff-multi-charm');
    const bagBasePrice = parseInt(container.dataset.ffBagBasePrice, 10) || 0;
    const section = getSection(container);
    const noneBtn = container.querySelector('[data-ff-charm-variant-id=""]');
    const productId = container.dataset.ffBagProductId;
    const charmPriceInSizes = container.hasAttribute('data-ff-charm-price-in-sizes');

    // El popup de tallas se inyecta de forma diferida al abrir el modal, por eso lo
    // resolvemos por id y observamos su llenado en vez de leerlo una sola vez al init.
    const modalInfo = productId ? document.getElementById('QuickAddInfo-' + productId) : null;

    function getSelectedCharmTotal() {
      return Array.from(container.querySelectorAll('.' + CLASS_SELECTED + '[data-ff-charm-price]'))
        .reduce((sum, el) => sum + (parseInt(el.dataset.ffCharmPrice, 10) || 0), 0);
    }

    function updateButtonPrice(charmTotal) {
      // Se re-resuelve en cada llamada: si la seccion re-renderiza el boton, una
      // referencia cacheada quedaria apuntando a un nodo desprendido.
      const submitBtn = section.querySelector('[data-ff-atc-button]');
      if (!submitBtn || !bagBasePrice) return;
      let span = submitBtn.querySelector('.ff-charm-total');
      if (charmTotal <= 0) {
        if (span) span.remove();
        return;
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'ff-charm-total';
        span.style.marginLeft = '10px';
        const spinner = submitBtn.querySelector('.loading__spinner');
        if (spinner) submitBtn.insertBefore(span, spinner);
        else submitBtn.appendChild(span);
      }
      span.textContent = formatMoney(bagBasePrice + charmTotal);
    }

    function getVariantMap() {
      const script = modalInfo && modalInfo.querySelector('variant-selects script[type="application/json"]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent).reduce((map, v) => {
          map[v.id] = v;
          return map;
        }, {});
      } catch (e) {
        return null;
      }
    }

    function updatePopupPrices(charmTotal) {
      if (!charmPriceInSizes || !modalInfo) return;
      const priceWraps = modalInfo.querySelectorAll('.ff-quick-add-prices');
      if (!priceWraps.length) return;
      const variantMap = getVariantMap();
      if (!variantMap) return;
      priceWraps.forEach((wrap) => {
        const label = wrap.closest('label[data-variant-property]');
        const variant = label && variantMap[label.dataset.variantProperty];
        if (!variant) return;
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        let html = '';
        if (hasCompare) {
          html += '<span class="ff-quick-compare-price">' + formatMoney(variant.compare_at_price + charmTotal) + '</span>';
        }
        html += formatMoney(variant.price + charmTotal);
        wrap.innerHTML = html;
        // El rewrite via innerHTML no deja el whitespace que separaba compare y sale
        // en el markup original; el modificador aporta ese gap sin tocar la clase
        // global .ff-quick-compare-price (usada por todos los quick-add del sitio).
        wrap.classList.toggle('ff-quick-add-prices--charm', hasCompare);
      });
    }

    function updatePrice() {
      const charmTotal = getSelectedCharmTotal();
      updateButtonPrice(charmTotal);
      updatePopupPrices(charmTotal);
    }

    // subtree:false para no reentrar: solo interesa la inyeccion del contenido del
    // modal (hijo directo). Los innerHTML de precios van a nodos mas profundos.
    if (charmPriceInSizes && modalInfo) {
      new MutationObserver(() => updatePopupPrices(getSelectedCharmTotal())).observe(modalInfo, {
        childList: true,
      });
    }

    function selectOption(chosen) {
      if (isMulti) {
        const isNone = chosen.dataset.ffCharmVariantId === '';
        if (isNone) {
          options.forEach((opt) => { opt.classList.remove(CLASS_SELECTED); opt.setAttribute('aria-pressed', 'false'); });
          chosen.classList.add(CLASS_SELECTED);
          chosen.setAttribute('aria-pressed', 'true');
        } else {
          if (noneBtn) { noneBtn.classList.remove(CLASS_SELECTED); noneBtn.setAttribute('aria-pressed', 'false'); }
          const wasSelected = chosen.classList.contains(CLASS_SELECTED);
          chosen.classList.toggle(CLASS_SELECTED, !wasSelected);
          chosen.setAttribute('aria-pressed', String(!wasSelected));
          const anyCharm = Array.from(options).some((o) => o.dataset.ffCharmVariantId !== '' && o.classList.contains(CLASS_SELECTED));
          if (!anyCharm && noneBtn) { noneBtn.classList.add(CLASS_SELECTED); noneBtn.setAttribute('aria-pressed', 'true'); }
        }
      } else {
        options.forEach((opt) => { opt.classList.toggle(CLASS_SELECTED, opt === chosen); opt.setAttribute('aria-pressed', String(opt === chosen)); });
      }
      updatePrice();
    }

    const isOptDisabled = (opt) => opt.disabled || opt.getAttribute('aria-disabled') === 'true';
    options.forEach((opt) => {
      opt.addEventListener('click', (e) => {
        if (isOptDisabled(opt)) return;
        if (e.target.closest('.ff-bags-cross-sell__zoom-opener')) return;
        selectOption(opt);
      });
      if (opt.getAttribute('role') === 'button') {
        opt.addEventListener('keydown', (e) => {
          if (e.target !== opt) return;
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          if (isOptDisabled(opt)) return;
          e.preventDefault();
          selectOption(opt);
        });
      }
    });

    // La opcion marcada por defecto la decide Liquid, asi que el precio inicial hay que
    // sincronizarlo aqui: sin esto el recargo del charm preseleccionado no aparece hasta
    // que el usuario hace el primer click.
    updatePrice();

    const productFormEl = section.querySelector('product-form');
    if (!productFormEl) return;

    productFormEl.addEventListener(
      'submit',
      function handleAtcSubmit(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const form = productFormEl.querySelector('form');
        if (!form) return;

        const variantInput = form.querySelector(SEL_VARIANT_INPUT);
        if (!variantInput || variantInput.disabled) return;

        const bagVariantId = parseInt(variantInput.value, 10);
        if (!bagVariantId) return;

        const selectedCharms = Array.from(container.querySelectorAll(
          '.' + CLASS_SELECTED + '[data-ff-charm-variant-id]:not([data-ff-charm-variant-id=""])'
        ));

        const bagShippingEl = section.querySelector('.bags-estimated-shipping[data-date-property]');
        const bagShippingProperty = bagShippingEl?.dataset.dateProperty || 'Shipping Ready';

        let items;
        if (selectedCharms.length) {
          const bagId = 'bag-' + Date.now();
          items = selectedCharms.map((charm) => ({
            id: parseInt(charm.dataset.ffCharmVariantId, 10),
            quantity: 1,
            properties: { _parent_bag_id: bagId, [charm.dataset.dateProperty || 'Shipping Ready']: 1 },
          }));
          const bagProps = { _bag_id: bagId, [bagShippingProperty]: 1 };
          if (isMulti) bagProps._multi_charm = '1';
          items.push({ id: bagVariantId, quantity: 1, properties: bagProps });
        } else {
          items = [{ id: bagVariantId, quantity: 1, properties: { _bag_id: '', [bagShippingProperty]: 1 } }];
        }

        const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        const submitBtn = productFormEl.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        cartEl && cartEl.setActiveElement(document.activeElement);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          items,
          sections: cartEl ? cartEl.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        });

        fetch(routes.cart_add_url, config)
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                errors: response.errors || response.description,
                message: response.message,
              });
              productFormEl.handleErrorMessage && productFormEl.handleErrorMessage(response.description);

              const soldOutMessage = submitBtn && submitBtn.querySelector('.sold-out-message');
              if (soldOutMessage) {
                submitBtn.setAttribute('aria-disabled', 'true');
                submitBtn.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              return;
            }

            if (!cartEl) { window.location = routes.cart_url; return; }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: response,
            });
            cartEl.renderContents(response);
          })
          .catch(console.error)
          .finally(() => {
            if (submitBtn) {
              submitBtn.classList.remove('loading');
              submitBtn.removeAttribute('aria-disabled');
              const spinner = submitBtn.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }
            if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          });
      },
      true
    );
  }

  function init() {
    document.querySelectorAll(SEL_CHARM_SELECTOR).forEach(initCharmSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
